import { useEffect, useState } from 'react'
import type { FieldValues, UseFormReset, UseFormResetField } from 'libs/form'
import { DEFAULT_COLOR } from 'features/areaTypes/areaTypes.config'
import type { AreaTypeItem } from 'features/areaTypes/types/areaTypes.types'
import { dataURLtoFile, getBase64FromUrl } from 'features/settings/utils/utils'

type UsePopulateAreaTypeProps = {
	data: AreaTypeItem | undefined
	reset: UseFormReset<FieldValues>
	resetField: UseFormResetField<FieldValues>
}

export const usePopulateAreaType = ({ data, reset, resetField }: UsePopulateAreaTypeProps) => {
	const [image, setImage] = useState<File | null>(null)

	useEffect(() => {
		if (!data) return

		let isCurrent = true

		reset({
			name: data.name,
			description: data.description,
			dimensions: {
				height: +data.dimensions?.height,
				width: +data.dimensions?.width,
				depth: +data.dimensions?.depth
			},
			availability_algorithm: data.availability_algorithm ?? 'any_available',
			primary_color: data.primary_color || DEFAULT_COLOR,
			secondary_color: data.secondary_color || DEFAULT_COLOR,
			image: null
		})
		setImage(null)

		if (data.image) {
			const name = new URL(data.image).pathname.split('/').pop() as string

			getBase64FromUrl(data.image).then((dataUrl) => {
				if (!isCurrent) return

				const file = dataURLtoFile(dataUrl as string, name)

				setImage(file)
				resetField('image', { defaultValue: file })
			})
		}

		return () => {
			isCurrent = false
		}
	}, [data])

	return image
}
